"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyObjectsRegistry = void 0;
const uuid_1 = require("uuid");
/**
 * Registry pattern to resolve parent-child relationships without circular references.
 * This allows child objects to access their parents through UUID lookups.
 */
class SurveyObjectsRegistry {
    constructor() {
        this._uuid = (0, uuid_1.v4)();
        this._interviews = new Map();
        this._places = new Map();
        this._households = new Map();
        this._persons = new Map();
        this._vehicles = new Map();
        this._organizations = new Map();
        this._journeys = new Map();
        this._visitedPlaces = new Map();
        this._trips = new Map();
        this._tripChains = new Map();
        this._segments = new Map();
        this._junctions = new Map();
        this._uuid = (0, uuid_1.v4)();
    }
    get uuid() {
        return this._uuid;
    }
    // Registration methods
    registerInterview(interview) {
        if (interview.uuid) {
            this._interviews.set(interview.uuid, interview);
        }
    }
    registerPlace(place) {
        if (place.uuid) {
            this._places.set(place.uuid, place);
        }
    }
    registerHousehold(household) {
        if (household.uuid) {
            this._households.set(household.uuid, household);
        }
    }
    registerPerson(person) {
        if (person.uuid) {
            this._persons.set(person.uuid, person);
        }
    }
    registerVehicle(vehicle) {
        if (vehicle.uuid) {
            this._vehicles.set(vehicle.uuid, vehicle);
        }
    }
    registerOrganization(organization) {
        if (organization.uuid) {
            this._organizations.set(organization.uuid, organization);
        }
    }
    registerJourney(journey) {
        if (journey.uuid) {
            this._journeys.set(journey.uuid, journey);
        }
    }
    registerVisitedPlace(visitedPlace) {
        if (visitedPlace.uuid) {
            this._visitedPlaces.set(visitedPlace.uuid, visitedPlace);
        }
    }
    registerTrip(trip) {
        if (trip.uuid) {
            this._trips.set(trip.uuid, trip);
        }
    }
    registerTripChain(tripChain) {
        if (tripChain.uuid) {
            this._tripChains.set(tripChain.uuid, tripChain);
        }
    }
    registerSegment(segment) {
        if (segment.uuid) {
            this._segments.set(segment.uuid, segment);
        }
    }
    registerJunction(junction) {
        if (junction.uuid) {
            this._junctions.set(junction.uuid, junction);
        }
    }
    // Lookup methods
    getInterview(uuid) {
        return this._interviews.get(uuid);
    }
    getPlace(uuid) {
        return this._places.get(uuid);
    }
    getHousehold(uuid) {
        return this._households.get(uuid);
    }
    getPerson(uuid) {
        return this._persons.get(uuid);
    }
    getVehicle(uuid) {
        return this._vehicles.get(uuid);
    }
    getOrganization(uuid) {
        return this._organizations.get(uuid);
    }
    getJourney(uuid) {
        return this._journeys.get(uuid);
    }
    getVisitedPlace(uuid) {
        return this._visitedPlaces.get(uuid);
    }
    getTrip(uuid) {
        return this._trips.get(uuid);
    }
    getTripChain(uuid) {
        return this._tripChains.get(uuid);
    }
    getSegment(uuid) {
        return this._segments.get(uuid);
    }
    getJunction(uuid) {
        return this._junctions.get(uuid);
    }
    // Cleanup methods
    clear() {
        this._interviews.clear();
        this._places.clear();
        this._households.clear();
        this._persons.clear();
        this._vehicles.clear();
        this._organizations.clear();
        this._journeys.clear();
        this._visitedPlaces.clear();
        this._trips.clear();
        this._tripChains.clear();
        this._segments.clear();
        this._junctions.clear();
    }
    unregisterInterview(uuid) {
        this._interviews.delete(uuid);
    }
    unregisterPlace(uuid) {
        this._places.delete(uuid);
    }
    unregisterHousehold(uuid) {
        this._households.delete(uuid);
    }
    unregisterPerson(uuid) {
        this._persons.delete(uuid);
    }
    unregisterVehicle(uuid) {
        this._vehicles.delete(uuid);
    }
    unregisterOrganization(uuid) {
        this._organizations.delete(uuid);
    }
    unregisterJourney(uuid) {
        this._journeys.delete(uuid);
    }
    unregisterVisitedPlace(uuid) {
        this._visitedPlaces.delete(uuid);
    }
    unregisterTrip(uuid) {
        this._trips.delete(uuid);
    }
    unregisterTripChain(uuid) {
        this._tripChains.delete(uuid);
    }
    unregisterSegment(uuid) {
        this._segments.delete(uuid);
    }
    unregisterJunction(uuid) {
        this._junctions.delete(uuid);
    }
}
exports.SurveyObjectsRegistry = SurveyObjectsRegistry;
//# sourceMappingURL=SurveyObjectsRegistry.js.map